import { ReleaseType } from '@ibk/shared-types';
import { formatCurrency } from '@ibk/shared-utils';
import { DEFAULT_CURRENCY_VALUE, getUnformatedValue } from '../../utils';
export function buildLegacyProductCalculation(product) {
    const releaseType = product.releaseType ?? ReleaseType.MONTHLY;
    let globalValue = DEFAULT_CURRENCY_VALUE;
    if (releaseType === ReleaseType.DAILY && product.amountDaily) {
        globalValue = formatCurrency(product.amountDaily);
    }
    else if (releaseType === ReleaseType.MONTHLY && product.baseValue) {
        globalValue = formatCurrency(product.baseValue);
    }
    return {
        releaseType,
        globalValue,
        amountDaily: releaseType === ReleaseType.DAILY ? getUnformatedValue(globalValue) : undefined,
    };
}
export function legacyProductCalculationSignature(voucherTypeId, calculation) {
    return `${voucherTypeId}:${calculation.releaseType}:${calculation.globalValue}`;
}
export function shouldSyncLegacyProductCalculation(params) {
    if (!params.appliedSignature || params.appliedSignature === params.productSignature) {
        return false;
    }
    return params.appliedSignature === params.formSignature;
}
